import { instance } from './index';

// 회원가입
function registerUser(userData) {
  return instance.post('user/signUp', null, { params: userData });
}

// 로그인
function loginUser(userData) {
  return instance.post('user/signIn', null, { params: userData });
}

// 패스워드 리셋
function passwordReset(userData) {
  return instance.post('user/sendEmail', null, { params: userData });
}

// 인증번호 전송
function sendAuthCode(phn) {
  return instance.post('user/send_auth_code', null, { params: { phn : phn } });
}

// 인증하기
function crtfctAuthCode(userData) {
  return instance.post('user/crtfct_auth_code', null, { params: userData });
}

// 휴대폰번호로 이메일 찾기
function findEmailByPhn(phn) {
  return instance.post('user/findEmailByPhn', null, { params: { phn : phn } });
}

// 휴대폰번호로 회원정보 조회
function getUserInfoByPhn(phn) {
  return instance.post('user/getUserInfoByPhn', null, { params: { phn : phn } });
}

export { registerUser, loginUser, passwordReset, sendAuthCode, crtfctAuthCode, findEmailByPhn, getUserInfoByPhn };
